import React, { useEffect, useState } from "react";
import Select from "react-select";
import { getApi } from "../../../utils/api";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { ThreeDots } from "react-loader-spinner";
import NoRecordsAvailable from "../../NoRecordsAvailable";
import { MdKeyboardArrowDown, MdOutlineKeyboardArrowUp } from "react-icons/md";
import {
  GET_CSAT_PROJECT_DETAILS_BY_PROJECT_ID,
  GET_ALL_CSAT_PROJECTS_BY_EMPLOYEE_ID,
  GET_CSAT_RATINGS_PROJECT_LIST,
} from "../../../config/Endpoints";

import { useEmployeeStore } from "../../../stores/employeeListStore";
import { displayFormatDate } from "../../../utils/helpers";
import { projectTypeOptions } from "../../../options/projectTypesOptions";
import CSATViewTeamMembersRatingTable from "./CSATViewTeamMembersRatingTable";

const ManageCSATRatings = () => {
  const [projects, setProjects] = useState([]);
  const [employeeProjects, setEmployeeProjects] = useState([]);
  const [selectedFilterType, setSelectedFilterType] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [loading, setLoading] = useState(false);
  const [employeeLoading, setEmployeeLoading] = useState(false);
  const [projectDetailsById, setProjectDetailsById] = useState({});
  const [projectDetailsLoadingById, setProjectDetailsLoadingById] = useState(
    {}
  );

  const accessToken = Cookies.get("accessToken");
  const { employeeList, fetchEmployees } = useEmployeeStore();

  const filterOptions = [
    { value: "project", label: "Project Name" },
    { value: "employee", label: "Employee Name" },
  ];
  const [projectDetails, setProjectDetails] = useState(null);
  const [projectDetailsLoading, setProjectDetailsLoading] = useState(false);

  const getProjectTypeLabel = (value) => {
    const option = projectTypeOptions.find((opt) => opt.value === value);
    return option ? option.label : projectDetails?.projectType;
  };

  const [openProjectId, setOpenProjectId] = useState(null);
  const toggleProject = async (projectId) => {
    const isOpen = openProjectId === projectId;
    setOpenProjectId(isOpen ? null : projectId);

    if (!isOpen && !projectDetailsById[projectId]) {
      setProjectDetailsLoadingById((prev) => ({ ...prev, [projectId]: true }));
      try {
        const res = await getApi(
          `${GET_CSAT_PROJECT_DETAILS_BY_PROJECT_ID}/${projectId}`,
          accessToken
        );
        if (
          res.data?.statusCode === 200 &&
          Array.isArray(res.data.data) &&
          res.data.data.length > 0
        ) {
          setProjectDetailsById((prev) => ({
            ...prev,
            [projectId]: res.data.data[0],
          }));
        } else if (res.data?.statusCode === 400 && res.data?.data === null) {
          setProjectDetailsById((prev) => ({
            ...prev,
            [projectId]: { csatMembers: [] },
          }));
        } else {
          toast.error(res.data?.message || "Error fetching project details");
        }
      } catch (err) {
        console.error(err);
        toast.error("Error fetching project details.");
      } finally {
        setProjectDetailsLoadingById((prev) => ({
          ...prev,
          [projectId]: false,
        }));
      }
    }
  };

  useEffect(() => {
    const fetchProjects = async () => {
      setLoading(true);
      try {
        const res = await getApi(GET_CSAT_RATINGS_PROJECT_LIST, accessToken);

        const { statusCode, data } = res.data;

        const list = Array.isArray(data) ? data : [];
        const formatted = list.map((p) => ({
          value: p.projectId,
          label: p.projectName,
        }));

        setProjects(formatted);
      } catch (err) {
        if (
          err.response?.data?.statusCode === 400 &&
          err.response?.data?.data === null
        ) {
          setProjects([]);
          return;
        }
        toast.error(err.response?.data?.message || "Error fetching projects.");
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
    fetchEmployees();
  }, [fetchEmployees]);

  useEffect(() => {
    const fetchEmployeeProjects = async () => {
      if (selectedFilterType?.value === "employee" && selectedOption) {
        setEmployeeProjects([]);
        setEmployeeLoading(true);
        try {
          const res = await getApi(
            `${GET_ALL_CSAT_PROJECTS_BY_EMPLOYEE_ID}/${selectedOption.value}`,
            accessToken
          );

          const { statusCode, data, message } = res.data || {};

          if (statusCode === 200 && data) {
            const projects = Array.isArray(data) ? data : [data];
            setEmployeeProjects(projects);
          } else if (statusCode === 400 && data === null) {
            setEmployeeProjects([]);
          } else {
            toast.error(message || "Error fetching employee projects.");
            setEmployeeProjects([]);
          }
        } catch (err) {
          console.error(err);
          if (
            err.response?.data?.statusCode === 400 &&
            err.response?.data?.data === null
          ) {
            setEmployeeProjects([]);
            return;
          }

          toast.error("Error fetching employee projects.");
          setEmployeeProjects([]);
        } finally {
          setEmployeeLoading(false);
        }
      } else {
        setEmployeeProjects([]);
      }
    };

    fetchEmployeeProjects();
  }, [selectedFilterType, selectedOption]);

  useEffect(() => {
    const fetchProjectDetailsById = async () => {
      if (selectedFilterType?.value === "project" && selectedOption) {
        setProjectDetailsLoading(true);
        try {
          const res = await getApi(
            `${GET_CSAT_PROJECT_DETAILS_BY_PROJECT_ID}/${selectedOption.value}`,
            accessToken
          );
          console.log(res.data);

          if (
            res.data?.statusCode === 200 &&
            Array.isArray(res.data.data) &&
            res.data.data.length > 0
          ) {
            setProjectDetails(res.data.data[0]);
          } else if (res.data?.statusCode === 400 && res.data?.data === null) {
            setProjectDetails({ csatMembers: [] });
          } else {
            toast.error(res.data?.message || "Error fetching project details.");
            setProjectDetails(null);
          }
        } catch (err) {
          console.error(err);
          toast.error("Error fetching project details.");
        } finally {
          setProjectDetailsLoading(false);
        }
      } else {
        setProjectDetails(null);
      }
    };

    fetchProjectDetailsById();
  }, [selectedOption, selectedFilterType]);

  const secondFilterOptions =
    selectedFilterType?.value === "project" ? projects : employeeList;

  return (
    <>
      <div className="card csat-rating-filters-card rounded-lg">
        <div className="row col-md-12 g-3 justify-content-center">
          <div className="col-md-5">
            <Select
              placeholder="Filter By"
              options={filterOptions}
              value={selectedFilterType}
              onChange={(val) => {
                setSelectedFilterType(val);
                setSelectedOption(null);
              }}
              isClearable
            />
          </div>

          <div className="col-md-5">
            <Select
              placeholder={
                selectedFilterType?.label
                  ? `Select ${selectedFilterType.label}`
                  : "Select Option"
              }
              options={secondFilterOptions}
              value={selectedOption}
              onChange={setSelectedOption}
              isDisabled={!selectedFilterType}
              isClearable
            />
          </div>
        </div>
      </div>
      {projectDetailsLoading ? (
        <div className="d-flex justify-content-center mt-4">
          <ThreeDots
            height="80"
            width="80"
            radius="9"
            color="blue"
            ariaLabel="three-dots-loading"
          />
        </div>
      ) : (
        projectDetails && (
          <div className="mt-4 px-3">
            <div className="row">
              <div className="col-md-12">
                <div className="row mb-2 g-0 d-flex align-items-stretch">
                  <div className="col-md-6 px-4 mt-2 d-flex flex-column project-details">
                    <div className="row p-2 align-items-center">
                      <label className="col-md-4 text-black-50 mb-2">
                        Project Name
                      </label>
                      <div className="col-md-8 px-4 py-2 rounded-2 project-details-field ">
                        {projectDetails.projectName}
                      </div>
                    </div>

                    <div className="row p-2 align-items-center">
                      <label className="col-md-4 text-black-50 mb-2">
                        Project Type
                      </label>
                      <div className="col-md-8 px-4 py-2 rounded-2 project-details-field ">
                        {getProjectTypeLabel(projectDetails.projectType)}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 px-4 mt-2 d-flex flex-column project-details">
                    {/* Delivery Lead */}
                    <div className="row p-2 align-items-center">
                      <label className="col-md-4 text-black-50 mb-2">
                        Delivery Lead
                      </label>
                      <div className="col-md-8 px-4 py-2 rounded-2 project-details-field ">
                        {projectDetails.dlName}
                      </div>
                    </div>
                    {/* SOW Dates */}
                    <div className="row p-2 align-items-center">
                      <label className="col-md-4 text-black-50 mb-2">SOW</label>
                      <div className="col-md-8 d-flex gap-2 p-0">
                        <div className="position-relative project-date-box">
                          <span className="m-0 dateBadgeStyle">Start Date</span>
                          <div className="py-3 px-2 rounded-2 text-center dateBoxStyle">
                            {projectDetails.sowStartDate
                              ? displayFormatDate(projectDetails.sowStartDate)
                              : "Ongoing"}
                          </div>
                        </div>
                        <div className="position-relative project-date-box">
                          <span className="m-0 dateBadgeStyle">End Date</span>
                          <div className="py-3 px-2 rounded-2 text-center dateBoxStyle">
                            {projectDetails.sowEndDate
                              ? displayFormatDate(projectDetails.sowEndDate)
                              : "Ongoing"}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-4">
                    <CSATViewTeamMembersRatingTable
                      projectDetails={projectDetails}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      )}

      {selectedFilterType?.value === "employee" &&
        employeeProjects.length > 0 && (
          <div className="accordion mt-4" id="employeeProjectsAccordion">
            {employeeProjects.map((proj) => {
              const detailedProject =
                projectDetailsById[proj.projectId] || proj;
              return (
                <div
                  className="accordion-item project-accordion-item"
                  key={proj.projectId}
                >
                  <h2
                    className="accordion-header"
                    id={`heading-${proj.projectId}`}
                  >
                    <button
                      className={`accordion-button ${
                        openProjectId === proj.projectId ? "" : "collapsed"
                      }`}
                      type="button"
                      onClick={() => toggleProject(proj.projectId)}
                    >
                      <span>{proj.projectName}</span>

                      <span
                        className={`project-status-badge ${
                          proj.status === 1
                            ? "badge-complete"
                            : proj.status === 2
                            ? "badge-onhold"
                            : "badge-active"
                        }`}
                      >
                        {proj.status === 1
                          ? "Completed"
                          : proj.status === 2
                          ? "On Hold"
                          : "Active"}
                      </span>

                      {openProjectId === proj.projectId ? (
                        <MdOutlineKeyboardArrowUp className="dropdown-icon" />
                      ) : (
                        <MdKeyboardArrowDown className="dropdown-icon" />
                      )}
                    </button>
                  </h2>

                  <div
                    id={`collapse-${proj.projectId}`}
                    className={`accordion-collapse collapse ${
                      openProjectId === proj.projectId ? "show" : ""
                    }`}
                    data-bs-parent="#employeeProjectsAccordion"
                  >
                    <div className="accordion-body">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="row mb-2 g-0 d-flex ">
                            <div className="col-md-6 px-4 mt-2  d-flex flex-column project-details">
                              <div className="row p-2 align-items-center  ">
                                <label className="col-md-5  text-black-50 mb-2 ">
                                  Project Name
                                </label>
                                <div
                                  className="col-md-7 px-4 py-2 rounded-2 project-details-field"
                                  style={{
                                    wordBreak: "break-word",
                                    overflowWrap: "anywhere",
                                    whiteSpace: "normal",
                                  }}
                                >
                                  {detailedProject.projectName}
                                </div>
                              </div>
                              <div className="row p-2 align-items-center">
                                <label className="col-md-5  text-black-50 mb-2">
                                  Project Type
                                </label>
                                <div className="col-md-7 px-4 py-2 rounded-2 project-details-field ">
                                  {getProjectTypeLabel(
                                    detailedProject?.projectType
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6 px-4 mt-2  d-flex flex-column project-details">
                              <div className="row p-2 align-items-center">
                                <label className="col-md-5  text-black-50 mb-2">
                                  Delivery Lead
                                </label>
                                <div className="col-md-7 px-4 py-2 rounded-2 project-details-field ">
                                  {detailedProject?.dlName}
                                </div>
                              </div>
                              <div className="row p-2 align-items-center">
                                <label className="col-md-5 text-black-50 mb-2">
                                  SOW
                                </label>
                                <div className="col-md-7 d-flex gap-2 p-0">
                                  <div className="position-relative project-date-box">
                                    <span className="m-0 dateBadgeStyle">
                                      Start Date
                                    </span>
                                    <div className="py-3 px-2 rounded-2 text-center dateBoxStyle">
                                      {proj.sowStartDate
                                        ? displayFormatDate(
                                            detailedProject?.sowStartDate
                                          )
                                        : "Ongoing"}
                                    </div>
                                  </div>
                                  <div className="position-relative project-date-box">
                                    <span className="m-0 dateBadgeStyle">
                                      End Date
                                    </span>
                                    <div className="py-3 px-2 rounded-2 text-center dateBoxStyle">
                                      {proj.sowEndDate
                                        ? displayFormatDate(
                                            detailedProject?.sowEndDate
                                          )
                                        : "Ongoing"}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mt-4">
                          {projectDetailsLoadingById[proj.projectId] ? (
                            <div className="d-flex justify-content-center mt-4">
                              <ThreeDots height="60" width="60" color="blue" />
                            </div>
                          ) : projectDetailsById[proj.projectId] ? (
                            <CSATViewTeamMembersRatingTable
                              projectDetails={
                                projectDetailsById[proj.projectId]
                              }
                            />
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

      {selectedFilterType?.value === "employee" &&
        selectedOption &&
        (employeeLoading ? (
          <div className="d-flex justify-content-center mt-4">
            <ThreeDots
              height="80"
              width="80"
              radius="9"
              color="blue"
              ariaLabel="three-dots-loading"
            />
          </div>
        ) : (
          employeeProjects.length === 0 && <NoRecordsAvailable />
        ))}
    </>
  );
};

export default ManageCSATRatings;
